import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.less']
})
export class PageNotFoundComponent implements OnInit {

  missingPage: string;
  continueClicked = false;

  constructor(private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {
    this.missingPage = this.route.snapshot.url.join('/');
  }

  continue() {
    this.continueClicked = true;
    this.router.navigate(['/']);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/page-not-found.component.ts